import "@styles/auth.css";
import { initAuthLogin } from "@features/auth/login";
import { initPasswordReset } from "@features/auth/password-reset";
import { initRegistration } from "@features/auth/registration";

const isRegistrationPage = !!document.querySelector("[data-reg-init]");

if (!isRegistrationPage) {
  initAuthLogin();
  initPasswordReset();
  document.body.addEventListener("htmx:afterSettle", () => {
    initAuthLogin();
    initPasswordReset();
  });
}

initRegistration();
